
import React from 'react';
import { Sparkles } from 'lucide-react';
import ChatHeader from './ChatHeader';
import MessagesList from './MessagesList';
import MessageInput from './MessageInput';

interface Connection {
  id: string;
  full_name: string;
  avatar_url?: string;
}

interface Message {
  id: string;
  sender_id: string;
  recipient_id: string;
  content: string;
  created_at: string;
  sender_name?: string;
  sender_avatar?: string;
}

interface ChatAreaProps {
  selectedUser: Connection | null;
  messages: Message[];
  currentUserId?: string;
  onSendMessage: (message: string) => Promise<void>;
  loading: boolean;
}

const ChatArea: React.FC<ChatAreaProps> = ({
  selectedUser,
  messages,
  currentUserId,
  onSendMessage,
  loading
}) => {
  if (!selectedUser) {
    return (
      <div className="md:col-span-2 bg-card/50 backdrop-blur-sm border border-primary/20 rounded-xl overflow-hidden shadow-lg flex flex-col">
        <div className="h-full flex items-center justify-center">
          <div className="text-center">
            <Sparkles className="h-16 w-16 mx-auto mb-4 text-primary/30 animate-pulse" />
            <h3 className="text-lg font-semibold mb-2 text-foreground">Select a connection</h3>
            <p className="text-muted-foreground">
              Choose someone to start chatting with! ✨
            </p>
          </div>
        </div>
      </div>
    );
  }

  return (
    <div className="md:col-span-2 bg-card/50 backdrop-blur-sm border border-primary/20 rounded-xl overflow-hidden shadow-lg flex flex-col">
      <ChatHeader selectedUser={selectedUser} />
      <MessagesList messages={messages} currentUserId={currentUserId} />
      <MessageInput onSendMessage={onSendMessage} disabled={loading} />
    </div>
  );
};

export default ChatArea;
